import Textbox from "../../../components/Textbox";

const SyncShopBaseForm = (props: any) => {
  const { values, handleChange, errors, touched } = props;
  return (
    <div>
      <div className="subtitle clearfix">
        <h2 className="title2">Sync Main Shop Wizard</h2>
      </div>
      <div className="row">
        <div className="col-md-12">
          <Textbox
            name="username"
            placeholder="sachin_tyrnow"
            value={values.username}
            onChange={handleChange}
            label="Enter From Shop username"
            errorMessage={touched.username && errors.username}
          />
        </div>
      </div>
    </div>
  );
};

export default SyncShopBaseForm;
